import styles from '../../../publications/publications.module.scss'

const NoticeBox = ({ message }) => {
  return (
    <div className={styles.noticeBox}>
      <p>{message}</p>
    </div>
  )
}

export default NoticeBox
